const masthead = document.querySelector('[data-masthead]')
const shell = document.querySelector('[data-shell]')
let isScrolled = false

function getMastheadHeight() {
	return masthead.getBoundingClientRect().height
}

function getAdminBarHeight() {
	const hasAdminBarClass = document.body.classList.contains('admin-bar')
	const wpadminbar = document.querySelector('#wpadminbar')

	if (!hasAdminBarClass) {
		return 0
	}
	return wpadminbar ? wpadminbar.getBoundingClientRect().height : 32
}

function getSupportMenuHeight() {
	const supportMenu = document.querySelector('.aimms-support-menu')
	if (!supportMenu) return 0

	return supportMenu.getBoundingClientRect().height
}

function getScrollCompHeight() {
	if (masthead.classList.contains('is-be-inverted')) {
		return 0
	}
	return isScrolled ? 32 : 0
}

function sizeNav() {
	const mastheadHeight = getMastheadHeight()
	const adminBarHeight = getAdminBarHeight()
	const supportMenuHeight = getSupportMenuHeight()

	shell.style.setProperty('--pad-top', `${mastheadHeight}px`)

	document.body.style.setProperty('--body-offset', `${adminBarHeight + supportMenuHeight}px`)
}

if (masthead) {
	sizeNav()

	window.addEventListener('resize', sizeNav)
	window.addEventListener('AimmsSupportMenuRender', sizeNav)
	window.addEventListener('AlertBannerToggle', () => {
		sizeNav()

		// Size progressively for 0.25s to match close animation roughly
		let counter = 0
		let resizer = setInterval(() => {
			sizeNav()
			counter += 1
			if (counter >= 6) {
				clearInterval(resizer)
			}
		}, 50)
	})

	new ResizeObserver(() => {
		sizeNav()
	}).observe(document.body)
}
